// ==========================================================================
// This is the core Javascript file to power the theme. Do not modify this
// file as it will be overwritten during update. To write scripts
// specifically for the project, use another file e.g. custom.js
// ==========================================================================

jQuery(document).ready(function($) {
  // WordPress Helper
  if ($('iframe').length) {
    $('iframe').each(function(index, el) {
      if ($(el).parent().is('p')) {
        let theRatio = ($(el).height()) / ($(el).width()) * 100 + '%';
        $(el).unwrap().wrap('<div class="gs-proportional"></div>')
          .parent().css('padding-bottom', theRatio);
      }
    });
  }
});
